import React from 'react';
import { Form } from 'antd';
import CustomForm from 'src/components/CustomForm';
import { PROFILE_FIELDS } from 'src/utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import adminActions from 'src/redux/actions/adminActions';
import adminSelectors from 'src/redux/selectors/adminSelectors';
import Loading from 'src/components/Loading';

const Profile = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const admin = useSelector(adminSelectors.admin);
  const loading = useSelector(adminSelectors.loading);
  const shouldUpdatePassword = Form.useWatch('shouldUpdatePassword', form);

  const initialValues = {
    avatar: admin.photoURL,
    name: admin.displayName,
    email: admin.email
  }

  const onFinish = (values) => {
    console.log(values);
    dispatch(adminActions.updateProfile({
      ...values,
      avatar: Array.isArray(values.avatar) ? values.avatar[0] : undefined
    }, () => {
      form.resetFields(['currentPassword', 'newPassword']);
    }));
  };

  const ASYNC_PROFILE_FIELDS = PROFILE_FIELDS.map(field => {
    switch (field.name) {
      case 'currentPassword':
        return {
          ...field,
          inputProps: {
            ...field.inputProps,
            disabled: shouldUpdatePassword ? false : true
          },
          ...(shouldUpdatePassword && {
            rules: [
              {
                required: true,
              },
              {
                min: 6,
              },
            ]
          })
        };
      case 'newPassword':
        return {
          ...field,
          inputProps: {
            ...field.inputProps,
            disabled: shouldUpdatePassword ? false : true
          },
          ...(shouldUpdatePassword && {
            rules: [
              {
                required: true,
              },
              {
                min: 6,
              },
            ]
          })
        };
      case 'confirmNewPassword':
        return {
          ...field,
          inputProps: {
            ...field.inputProps,
            disabled: shouldUpdatePassword ? false : true
          },
          ...(shouldUpdatePassword && {
            rules: [
              {
                required: true,
              },
              {
                min: 6,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error('The password and confirmation password do not match'));
                },
              }),
            ]
          })
        };
      default:
        return field;
    }
  });

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <Loading loading={loading} />
      <CustomForm form={form} fields={ASYNC_PROFILE_FIELDS} autoComplete='off' layout='vertical' onFinish={onFinish} initialValues={initialValues} />
    </div>
  )
}

export default Profile;